import { render, staticRenderFns } from "./FlightInfoDeparture.vue?vue&type=template&id=00242214"
import script from "./FlightInfoDeparture.vue?vue&type=script&lang=js"
export * from "./FlightInfoDeparture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports